import React from 'react';
import { motion } from 'framer-motion';
import { Gamepad2Icon, UserIcon } from 'lucide-react';
export function PainSection() {
  return <section className="py-20 px-4" data-id="element-152">
      <div className="max-w-6xl mx-auto" data-id="element-153">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-154">
          {/* Teen */}
          <motion.div initial={{
          opacity: 0,
          x: -50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6
        }} className="glass-panel neon-box-green rounded-2xl p-8 relative overflow-hidden group" data-id="element-155">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#39FF14] to-transparent opacity-50" data-id="element-156"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-157">
              <div className="p-3 bg-[#39FF14]/10 rounded-lg text-[#39FF14]" data-id="element-158">
                <Gamepad2Icon size={32} data-id="element-159" />
              </div>
              <h3 className="text-2xl font-bold" data-id="element-160">Si eres un adolescente...</h3>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed" data-id="element-161">
              conoces la frustración de querer algo importante —una nueva
              herramienta tecnológica, un proyecto personal o un viaje— y notar
              que tus ahorros son inexistentes. Depender totalmente de otros
              para cada decisión de consumo limita tu crecimiento.{' '}
              <span className="text-[#39FF14] font-semibold" data-id="element-162">
                Es momento de tomar el control de tus propios recursos.
              </span>
            </p>
          </motion.div>

          {/* Parent */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.6,
          delay: 0.2
        }} className="glass-panel neon-box-purple rounded-2xl p-8 relative overflow-hidden" data-id="element-163">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-transparent via-[#8B5CF6] to-transparent opacity-50" data-id="element-164"></div>
            <div className="flex items-center gap-4 mb-6" data-id="element-165">
              <div className="p-3 bg-[#8B5CF6]/10 rounded-lg text-[#8B5CF6]" data-id="element-166">
                <UserIcon size={32} data-id="element-167" />
              </div>
              <h3 className="text-2xl font-bold" data-id="element-168">Si eres un padre...</h3>
            </div>
            <p className="text-gray-300 text-lg leading-relaxed" data-id="element-169">
              la preocupación es comprensible: quieres que tu hijo desarrolle la
              madurez necesaria para gestionar su futuro con orden. Temes que
              las decisiones impulsivas de hoy se conviertan en falta de
              estabilidad mañana. Este Blueprint cierra la brecha educativa que
              el colegio dejó abierta.
            </p>
          </motion.div>
        </div>
      </div>
    </section>;
}